import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Text } from "@dhxete/text";
const textStyle = {
  fontSize: "14px",
  color: "#666"
};
const DateItemStyle = styled.div`
  display: inline-block;
  width: 135px;
`;

const DataItem = ({
  className,
  serialNumber,
  productName,
  handleSelect,
  serialNumberAndProductName
}) => {
  // Handle yellow highlight for serial number
  const newSerialNumber = serialNumber.replace(serialNumberAndProductName, match => `<span style="background: #fff568;">${match}</span>`); // Handle yellow highlight for product name

  const newProductName = productName.replace( // Need to make it case insensitive
  serialNumberAndProductName, match => `<span style="background: #fff568;">${match}</span>`);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    onMouseDown: handleSelect
  }, /*#__PURE__*/React.createElement(DateItemStyle, null, /*#__PURE__*/React.createElement(Text, textStyle, newSerialNumber)), /*#__PURE__*/React.createElement(Text, textStyle, newProductName));
};

DataItem.propTypes = {
  className: PropTypes.string,
  serialNumber: PropTypes.string,
  productName: PropTypes.string,
  handleSelect: PropTypes.func,
  serialNumberAndProductName: PropTypes.string
};
export default styled(DataItem)`
  box-sizing: border-box;
  padding: 6px 10px;
  :hover {
    background: #eee;
    cursor: pointer;
  }
`;